/* IGV helpers
 * Prices stored and shown INCLUDE IGV (18%).
 * To desglose: subtract IGV backwards.
 */

export const IGV_RATE = 0.18;
export const IGV_DIVISOR = 1 + IGV_RATE; // 1.18

/** Given a price that already includes IGV, returns { subtotal, igv, total } */
export function desglosarIGV(totalConIGV) {
  const total    = parseFloat(totalConIGV) || 0;
  const subtotal = total / IGV_DIVISOR;
  const igv      = total - subtotal;
  return {
    subtotal: Math.round(subtotal * 100) / 100,
    igv:      Math.round(igv      * 100) / 100,
    total:    Math.round(total    * 100) / 100,
  };
}

/** Desglose for a full cart (array of {price, qty}) */
export function desgloseCarrito(items) {
  const total    = items.reduce((s, i) => s + i.price * i.qty, 0);
  return desglosarIGV(total);
}

export function fmt(n) {
  return 'S/ ' + (Math.round((n || 0) * 100) / 100).toFixed(2);
}
